import { Directive, ElementRef, Input, OnChanges, inject } from '@angular/core';

@Directive({
  selector: '[appFocus]',
  standalone: false,
})
export class AppFocusDirective implements OnChanges {
  private hostElement = inject(ElementRef);

  @Input() appFocus: boolean;

  ngOnChanges() {
    if (this.appFocus) {
      this.hostElement.nativeElement.focus();
    }
  }
}
